import { visit } from 'unist-util-visit';
import katex from 'katex';
import { Root } from 'hast';

/**
 * Плагин для rehype, добавляющий MathML в формулы KaTeX
 */
export default function rehypeKatexMathML() {
  return (tree: Root) => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    visit(tree, 'element', (node: any) => {
      if (
        node.tagName === 'span' &&
        node.properties?.className?.includes('katex')
      ) {
        // Получаем LaTeX-формулу
        const latex = node.children?.[0]?.value;
        if (!latex) return;

        // Генерируем KaTeX HTML с MathML
        const rendered = katex.renderToString(latex, {
          throwOnError: false,
          output: 'mathml' // Создает и KaTeX, и MathML
        });

        // Обновляем узел с новой разметкой
        node.children = [{ type: 'raw', value: rendered }];
      }
    });
  };
}
